import type { ResultMessage } from "@copilotkit/runtime-client-gql";
import {
	type ActionExecutionResult,
	COPILOT_ACTION_RENDERERS,
} from "../renderers";

type ActionName = keyof typeof COPILOT_ACTION_RENDERERS;

export const ActionRenderer = ({
	message,
}: {
	message: ResultMessage;
}) => {
	const validRenderer =
		COPILOT_ACTION_RENDERERS[message.actionName as ActionName];

	if (!validRenderer) {
		return null;
	}
	const executionResult =
		message.result === ""
			? { type: "error", message: "No result found" }
			: JSON.parse(message.result);

	// biome-ignore lint/suspicious/noExplicitAny: Result shape can vary
	const result = executionResult as ActionExecutionResult<any>;

	const { component: Component } = validRenderer;

	return <Component {...result.result} />;
};
